import { API, ResponseData } from "src/constant";
import { postWithPath, postWithUrl, getWithPath } from "src/utils/http";

export const ChatService = {
    postJobTitle: (data?: { jobTitle: string }): Promise<ResponseData<any>> => {
        return postWithPath(API.POST.POST_JOB_TITLE, {}, data);
    },

    postChatZNS: (params?: any): Promise<ResponseData<any>> => {
        return postWithPath(API.POST.POST_CHAT_ZNS, {}, params);
    },

    tracking: (data: any): Promise<ResponseData<any>> => {
        return postWithUrl(
            API.POST.ZCATRACKING,
            {},
            data
        );
    },

    postChatbot: (chatbotId?: string, data?: any): Promise<ResponseData<any>> => {
        return postWithUrl(API.POST.CHAT_WIDGET, { chatbot: chatbotId }, data);
    },
};

export const JobService = {
    getAllJobs: () => {
        return getWithPath(API.GET.JOB_LIST);
    },
};
